import store from '..'
import axios from 'axios'
import API from '@/common/api'

export default {
  namespaced: true,
  state: {
    list: [],
    checked: [],
    selected: {},
    filter: {
      word: '',
      ids: []
    }
  },
  mutations: {
    // radio 처리
    selectedCategory: function (state, id) {
      const findName = function (arr) {
        arr.forEach(x => {
          if (x.id === id) {
            state.selected = x
          } else {
            if (x.children && x.children.length) {
              findName(x.children)
            }
          }
        })
      }
      findName(state.list)
    },
    // 전체 checked 처리
    checkedAll: function (state) {
      const setState = function (arr) {
        arr.forEach(x => {
          state.checked.push(x.id)
          x.state = {
            ...x.state,
            checked: true
          }
          if (x.children && x.children.length) {
            setState(x.children)
          }
        })
      }
      setState(state.list)
      state.checked.push('uncategorized')
    },
    // 전체 unchecked 처리
    unCheckedAll: function (state) {
      state.checked = []
    },
    // parent 전체 open
    expandedAll: function (state) {
      const setState = function (arr) {
        arr.forEach(x => {
          if (x.children && x.children.length) {
            x.state = {
              ...x.state,
              expanded: true
            }
            setState(x.children)
          }
        })
      }
      setState(state.list)
    },
    updateChecked: function (state, data) {
      const categoryListIds = function () {
        let result = []
        const ids = function (arr) {
          arr.forEach(function (x) {
            if (x.children && x.children.length) {
              ids(x.children)
            }
            return result.push(x.id)
          })
          return result
        }
        return ids(state.list)
      }
      const setChecked = typeof (data) !== 'undefined' && data ? categoryListIds().filter(x => data.includes(x)) : []
      state.checked = setChecked
    },
    updateCheckedState: function (state, ids) {
      ids.forEach(function (id) {
        const findCategory = function (arr) {
          const mapArr = arr.map(function (x) {
            if (x.id === id) {
              x.state = { ...x.state, checked: true }
            }
            if (x.children && x.children.length) {
              x.state = { ...x.state, expanded: false }
              findCategory(x.children)
            }
            return x
          })
          return mapArr
        }
        findCategory(state.list)
      })
    },
    // checked ids
    setChecked: function (state, data) {
      const isChecked = data.isChecked
      const index = state.checked.indexOf(data.id)
      if (isChecked) {
        state.checked.push(data.id)
      } else {
        state.checked.splice(index, 1)
      }
    },
    setFilter: function (state, data) {
      Object.keys(data).forEach(function (x) {
        state.filter[x] = data[x]
      })
    }
  },
  actions: {
    setData ({ state }, data) {
      state.list = data
      return true
    },
    async getCategory () {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          ...API.GET_GVF_PARAMS,
          id: store.state.authentication.requestId,
          file: 'category/list.json'
        })
        return res.data.message
      } catch (ex) {
        // alert(ex)
        console.log(ex)
        return false
      }
    },
    async setCategory ({ state }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          ...API.SET_GVF_PARAMS,
          id: store.state.authentication.requestId,
          file: 'category/list.json',
          data: JSON.stringify(data)
        })
        return res.data.message
      } catch (ex) {
        alert(ex)
        console.log(ex)
        return false
      }
    },
    setCategoryData ({ dispatch }) {
      return dispatch('getCategory').then(res => {
        const data = !res ? [] : res
        dispatch('setData', data)
        return res
      }).catch((ex) => {
        // alert(ex)
        console.log(ex)
        return false
      })
    },
    updateCheckedPath ({ commit }, data) {
      commit('updateCheckedPath', data)
    }
  },
  getters: {
    list: state => {
      return state.list
    },
    ids: state => {
      let result = []
      const ids = function (arr) {
        arr.forEach(function (x) {
          if (x.children && x.children.length) {
            ids(x.children)
          }
          return result.push(x.id)
        })
        return result
      }
      return ids(state.list)
    },
    selected: state => {
      return state.selected
    },
    categoryInfo: state => id => {
      let info = ''
      const findInfo = function (arr) {
        arr.forEach(x => {
          if (x.id === id) {
            info = x
          } else {
            if (x.children && x.children.length) {
              findInfo(x.children)
            } else {
              return false
            }
          }
        })
      }
      findInfo(state.list)
      return info
    },
    // params: id / return 카테고리 패스 (카테고리패스는 카테고리 생성 후 저장할 때 한번에 parent depth 계산 후 데이터 추가됨)
    categoryPath: state => id => {
      let path = ''
      const findPath = function (arr) {
        arr.forEach(x => {
          if (x.id === id) {
            path = x.path
          } else {
            if (x.children && x.children.length) {
              findPath(x.children)
            } else {
              return false
            }
          }
        })
      }
      findPath(state.list)
      return path
    },
    // params: id / return 카테고리 이름(text)
    categoryName: state => id => {
      let name = ''
      const findName = function (arr) {
        arr.forEach(x => {
          if (x.id === id) {
            name = x.text
          } else {
            if (x.children && x.children.length) {
              findName(x.children)
            } else {
              return false
            }
          }
        })
      }
      findName(state.list)
      return name
    },
    getChecked: state => {
      return state.checked
    },
    getFilter: state => {
      return state.filter
    }
  }
}
